exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./pc_free_tag.svg"));

// Module
exports.push([module.id, ".index-add-animation-free-2cddx{background:50%/contain no-repeat url(" + ___CSS_LOADER_URL___0___ + ");width:26px;height:14px}", ""]);

// Exports
exports.locals = {
	"add-animation-free": "index-add-animation-free-2cddx"
};